import { Button, Image, Modal } from "antd";
import React, { useState } from "react";
import RejectModal from "../../Candidate/components/RejectModal";
import { CheckOutlined, CloseOutlined, EyeOutlined } from "@ant-design/icons";
import {
  Pending,
  ReadyForReview,
  Rejected,
  Verified,
} from "../../../components/components/StatusIndicators";
import useGetFile from "../../../hooks/useGetFile";
import useAxios from "../../../hooks/useAxios";
import useAuthUserToken from "../../../hooks/useAuthUserToken";
import AIRemarks from "../Components/AIRemarks";

const SignatureSection = ({
  candidateDetails,
  getCandidateDetails,
  setLoading,
  aiRemarks,
  canAcceptReject
}) => {
  const api = useAxios();
  const { userToken } = useAuthUserToken();
  const { getImage } = useGetFile(userToken);
  const [viewSign, setViewSign] = useState(false);
  const [signature, setSignature] = useState("");
  const [signatureType, setSignatureType] = useState("image");
  const [imgRejectReason, setImgRejectReason] = useState("");
  const [rejectModalSignature, setRejectModalSignature] = useState(false);

  const getFileExtension = (fileName = "") =>
    fileName.split(".").pop()?.toLowerCase() || "";

  const isPdfSignature = (file = {}) =>
    getFileExtension(file?.originalname || file?.filename || file?.path) ===
    "pdf";

  const rejectSignature = async (e) => {
    setLoading(true);
    try {
      await api.put(
        `/candidate/candidateSignatureStatus/${candidateDetails?._id}`,
        { Status: false, candidateSignatureRejection: imgRejectReason },
        { tokenType: "user" },
      );
      setRejectModalSignature(false);
      setImgRejectReason("");
      await getCandidateDetails();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const acceptSignature = async (e) => {
    setLoading(true);
    try {
      await api.put(
        `/candidate/candidateSignatureStatus/${candidateDetails?._id}`,
        { Status: true },
        { tokenType: "user" },
      );
      await getCandidateDetails();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const IS_REJECTED_SIGNATURE =
    candidateDetails?.candidateSignatureStatus !== null &&
    candidateDetails?.candidateSignatureStatus === false &&
    candidateDetails?.signatureFilledStatus === false;

  return (
    <>
      <div
        style={{
          ...(IS_REJECTED_SIGNATURE ? { border: "1px solid red" } : {}),
          position: "relative",
        }}
        className="card p-2 flex flex-row justify-between"
      >
        <div className="w-full">
          <div className="flex justify-between">
            <strong>Signature : </strong>
            {
              candidateDetails?.candidateSignature?.length !== 0 &&
              <AIRemarks aiRemarks={aiRemarks} docType={"Signature"}/>
            }
          </div>
          <div className="flex justify-between mt-3">
            <div>
              {canAcceptReject && (
                <>
                  <Button
                    disabled={
                      (candidateDetails?.candidateSignatureStatus &&
                        candidateDetails?.isEmpTempIdCreated) ||
                      candidateDetails?.candidateSignature?.length === 0
                    }
                    title="accept"
                    shape="circle"
                    type="success"
                    size="small"
                    icon={<CheckOutlined />}
                    style={{ marginRight: "4px" }}
                    onClick={() => acceptSignature()}
                  ></Button>
                  <Button
                    disabled={
                      (candidateDetails?.candidateSignatureStatus &&
                        candidateDetails?.isEmpTempIdCreated) ||
                      candidateDetails?.candidateSignature?.length === 0
                    }
                    title="reject"
                    shape="circle"
                    type="danger"
                    size="small"
                    icon={<CloseOutlined />}
                    style={{ marginRight: "4px" }}
                    onClick={() => {
                      setRejectModalSignature(true);
                    }}
                  ></Button>
                </>
              )}
              <Button
                title="view"
                shape="circle"
                type=""
                disabled={candidateDetails?.candidateSignature?.length === 0}
                size="small"
                icon={<EyeOutlined />}
                onClick={async () => {
                  const signatureFile = candidateDetails?.candidateSignature[0];
                  const img = await getImage(
                    signatureFile?.path,
                  );
                  setSignature(img);
                  setSignatureType(isPdfSignature(signatureFile) ? "pdf" : "image");
                  setViewSign(true);
                }}
                style={{ marginRight: "4px" }}
              ></Button>
            </div>
            <div>
              {candidateDetails?.signatureFilledStatus === false &&
              candidateDetails?.candidateSignatureStatus === null ? (
                <Pending />
              ) : (
                <>
                  {(candidateDetails?.candidateSignatureStatus === null ||
                    candidateDetails?.candidateSignatureStatus === false) &&
                  candidateDetails?.signatureFilledStatus === true ? (
                    <ReadyForReview />
                  ) : (
                    <>
                      {candidateDetails?.candidateSignatureStatus ? (
                        <Verified />
                      ) : (
                        <>
                          <Rejected />
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
        {IS_REJECTED_SIGNATURE && (
          <div
            className="d-flex gap-2 text-danger font-weight-bold"
            style={{ position: "absolute", bottom: -20, right: 0 }}
          >
            Reason : {candidateDetails?.candidateSignatureRejection}
          </div>
        )}
      </div>
      <Modal
        centered
        open={viewSign}
        onOk={(e) => setViewSign(!viewSign)}
        onCancel={(e) => setViewSign(!viewSign)}
        width={signatureType === "pdf" ? 900 : 500}
        title="Signature"
        footer={null}
      >
        <div className="d-flex justify-content-center p-4">
          {/* <div
            className={`signature mt-3 ${
              candidateDetails?.candidateSignature ? "" : "signature__active"
            }`}
          >
            {candidateDetails?.candidateSignature && (
              <img
                className="img"
                src={
                  documentType === "S3" && BASE.storageType
                    ? s3Files?.candidateSignature
                    : url() + candidateDetails?.candidateSignature[0]?.path
                }
                alt="signature"
              />
            )}
          </div> */}
          {signatureType === "pdf" ? (
            <iframe
              title="Signature PDF"
              src={signature}
              style={{ width: "100%", minHeight: "70vh", border: 0 }}
            />
          ) : (
            <Image src={signature} />
          )}
        </div>
      </Modal>
      <RejectModal
        open={rejectModalSignature}
        closeHandler={setRejectModalSignature}
        value={imgRejectReason}
        setValue={setImgRejectReason}
        onSubmit={() => rejectSignature()}
      />
    </>
  );
};

export default SignatureSection;
